// import React from "react";
// import FullWidth3DSlider from './FullWidth3DSlider';

// const Hero = () => {
//     return <FullWidth3DSlider />;
// };

// export default Hero;





import React from "react";
import FullWidth3DSlider from './FullWidth3DSlider';
import HeroTextOverlay from './HeroTextOverlay';

const Hero = ({ heroData }) => {
    if (!heroData) return null;

    const {
        fullwidth,
        logo_text,
        logo_subtitle,
        hero_title,
        hero_subtitle,
        hero_subtitle2,
        hero_subtitle3,
        hero_btn_one,
        btn_one_link,
        hero_btn_two,
        btn_two_link
    } = heroData;

    return (
        <div>
            {/* Full-width 3D slider */}
            <FullWidth3DSlider images={fullwidth.map(img => img.image)} />

            {/* Hero text overlay */}
            <HeroTextOverlay
                logoText={logo_text}
                logoSubtitle={logo_subtitle}
                heroTitle={hero_title}
                heroSubtitle={hero_subtitle}
                heroSubtitle2={hero_subtitle2}
                heroSubtitle3={hero_subtitle3}
                btnOneText={hero_btn_one}
                btnOneLink={btn_one_link}
                btnTwoText={hero_btn_two}
                btnTwoLink={btn_two_link}
            />
        </div>
    );
};

export default Hero;